import React, { Component } from "react";

export default class About extends Component {
  render() {
    return (
      <div>
        <section className="colorlib-about" data-section="about">
          <div className="colorlib-narrow-content">
            <div className="row">
              <div className="col-md-12">
                <div
                  className="row row-bottom-padded-sm animate-box"
                  data-animate-effect="fadeInLeft"
                >
                  <div className="col-md-12">
                    <div className="about-desc">
                      <span className="heading-meta">About Moi</span>
                      <h2 className="colorlib-heading">Who I am</h2>
                      <p>
                        I am a graduate of the Queensborough Community College
                        (QCC) CUNY TechWorks software development continuing
                        education program. Learning included competencies for
                        webclient programming, systems design and
                        implementation.
                      </p>
                      <p>
                        I'm a systems analyst who found his true passion in
                        programming. This is a direct result of co-founding a
                        technology education nonprofit which helps under-served
                        communities leverage technology resources to create
                        education and economic opportunity.
                      </p>
                      <p>
                        I love the combination of creative and logical
                        problem-solving skills I get to use when programming. As
                        a highly motivated and focused self-starter who learns
                        fast and executes faster, I will put forth my best
                        effort to be a valuable contributor to virtually any
                        team.{" "}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="colorlib-about">
          <div className="colorlib-narrow-content">
            <div className="row">
              <div
                className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box"
                data-animate-effect="fadeInLeft"
              >
                {/* <span className="heading-meta">What I do?</span> */}
                <h2 className="colorlib-heading">What I do</h2>
              </div>
            </div>
            <div className="row row-pt-md">
              <div className="col-md-4 text-center animate-box">
                <div className="services color-4">
                  <span className="icon">
                    <i className="icon-layers2" />
                  </span>
                  <div className="desc">
                    <h3>Test Automation</h3>
                    <p>
                      Design and write test automation scripts with frameworks.
                      Investigate problems as a result of testing
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-4 text-center animate-box">
                <div className="services color-1">
                  <span className="icon">
                    <i className="icon-chrome" />
                    {/* <i className="icon-bulb" /> */}
                  </span>
                  <div className="desc">
                    <h3>Web Development </h3>
                    <p>
                      Full stack JavaScript, React, Python, Django/Flask, Ruby,
                      Rails, Cloud, Databases
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-4 text-center animate-box">
                <div className="services color-6">
                  <span className="icon">
                    <i className="icon-data" />
                    {/* <i className="icon-phone3" /> */}
                  </span>
                  <div className="desc">
                    <h3>Data Structures & Algorithms</h3>
                    <p>
                      Solid understanding of fundamentals (Definate
                      work-in-progress tho' TBQH)
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="row row-pt-md">
              <div className="col-md-4 text-center animate-box">
                <div className="services color-2">
                  <span className="icon">
                    <i className="icon-data" />
                  </span>
                  <div className="desc">
                    <h3>Dev Ops</h3>
                    <p>Jenkins , Kubernetes , Docker </p>
                  </div>
                </div>
              </div>
              <div className="col-md-4 text-center animate-box">
                <div className="services color-3">
                  <span className="icon">
                    <i className="icon-phone3" />
                  </span>
                  <div className="desc">
                    <h3>Digital Marketing</h3>
                    <p>I use Instagram eight hours a day :) </p>
                  </div>
                </div>
              </div>
              <div className="col-md-4 text-center animate-box">
                <div className="services color-5">
                  <span className="icon">
                    <i className="icon-data" />
                  </span>
                  <div className="desc">
                    <h3>Dev Ops</h3>
                    <p>
                      I am pursuing my internship with DevOps team at Juniper
                      and working with tools like Jenkins, Docker, K8s
                    </p>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </section>
      </div>
    );
  }
}
